export default "__VITE_ASSET__CN_ptb3T__"